import React from 'react';
import en from '../../../translations/en.json';

function BasicDetailsTab({ album }) {
  const t = (key, fallback) => {
    const res = key.split('.').reduce((obj, i) => (obj ? obj[i] : null), en);
    return (res && typeof res === 'string') ? res : (fallback || key);
  };

  if (!album) return null;

  const albumName = album.name || album.title || 'Album NAME';
  const artistName = album.artist || album.artistName || album.artists || (album.songs && album.songs[0]?.artist) || 'Chamara Weerasinghe';
  const labelName = album.recordLabelName || album.label || 'Ransilu';
  const totalTracks = album.songCount ? `${album.songCount} tracks` : (album.tracks ? `${album.tracks} tracks` : (album.songs ? `${album.songs.length} tracks` : '12 tracks'));
  const releaseYear = album.release_year || album.releaseYear || album.year || (album.created_at ? new Date(album.created_at).getFullYear() : '—');
  const albumTag = album.tag || album.albumTag || album.recordLabelName || 'Album tag';

  const detailsList = [
    {
      id: 'albumName',
      label: t('albumDetails.rowAlbumName', 'Album Name'),
      value: albumName,
      icon: <span className="icon-text-aa">Aa</span>
    },
    {
      id: 'artist',
      label: t('albumDetails.rowArtist', 'Artist'),
      value: artistName,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      )
    },
    {
      id: 'label',
      label: t('albumDetails.rowLabel', 'Label'),
      value: labelName,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="12" cy="12" r="1" />
        </svg>
      )
    },
    {
      id: 'totalTracks',
      label: t('albumDetails.rowTotalTracks', 'Total Tracks'),
      value: totalTracks,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18V5l12-2v13" />
          <circle cx="6" cy="18" r="3" />
          <circle cx="18" cy="16" r="3" />
        </svg>
      )
    },
    {
      id: 'releaseYear',
      label: t('albumDetails.rowReleaseYear', 'Release Year'),
      value: releaseYear,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      )
    },
    {
      id: 'albumTag',
      label: t('albumDetails.rowAlbumTag', 'Album Tag'),
      value: albumTag,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
          <line x1="7" y1="7" x2="7.01" y2="7" />
        </svg>
      )
    }
  ];

  return (
    <div className="basic-details-tab">
      <div className="album-details-table-list">
        {detailsList.map((item) => (
          <div key={item.id} className="album-detail-item-row">
            <div className="item-icon-box">
              {item.icon}
            </div>
            <div className="item-label-text">
              {item.label}
            </div>
            <div className="item-value-text">
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BasicDetailsTab;
